import { Input as AntdInput, type InputProps } from 'antd'

export const Input = (props: InputProps) => <AntdInput {...props} />
